import React from 'react';
import PropTypes from 'prop-types';

const ChevronLeftIcon = ({ className, color }) => (
  <svg
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='17'
    viewBox='0 0 12 17'
  >
    <path
      fill='#FFF'
      fillRule='evenodd'
      d='M2.828 8.485l6.364 6.364a1 1 0 1 1-1.414 1.414l-7.07-7.07a1 1 0 0 1 0-1.415l7.07-7.07A1 1 0 1 1 9.192 2.12L2.828 8.485z'
    />
  </svg>
);

ChevronLeftIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default ChevronLeftIcon;



// WEBPACK FOOTER //
// ./src/icons/ChevronLeftIcon.js